module.exports = __webpack_public_path__ + "static/img/warning--filled2.214f37fa.svg";